import React, { useContext } from 'react';
import tw from 'twin.macro';
import { PreferenceContext } from '../context';
import { Icon } from '../icon';
import { TimesIcon } from 'icons';
import { Small } from '../text';

export const Notification = ({
  message,
  success,
  warning,
  danger,
  info,
  style,
  isHtml = false,
  onClick = null,
  ...restProps
}) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const isLightTheme = theme === 'light';
  return (
    <div
      css={[
        tw`flex justify-between items-center font-bold p-2 rounded-md text-dark bg-icons gap-0.5`,
        (success || style === 'success') && tw`bg-success`,
        (warning || style === 'warning') && tw`bg-warning`,
        (danger || style === 'danger' || style === 'error') && tw`bg-danger`,
        (info || style === 'info') && tw`bg-info`,
      ]}
      {...restProps}
    >
      {!isHtml && <Small text={message} tw='!text-dark opacity-100' />}
      {isHtml && (
        <Small dangerouslySetInnerHTML={{ __html: message }} tw='!text-dark opacity-100' />
      )}
      <div onClick={onClick || null}>
        <Icon
          Type={TimesIcon}
          aria-hidden='true'
          color={isLightTheme ? 'input-front' : 'input-back'}
          tw='cursor-pointer hover:opacity-30'
        />
      </div>
    </div>
  );
};
